import React, { useCallback, useEffect } from "react";
import ReactQuill from "react-quill";
import { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { MentionBlot } from "../../utils/CustomMentionBlot";

if (!Quill.imports["formats/mention"]) {
  Quill.register(MentionBlot);
}

export const CustomReactQuill = ({ quillRef, placeholder, modules }) => {
  // Register MentionBlot before rendering ReactQuill

  const handleUndo = useCallback(() => {
    if (quillRef.current) {
      const editor = quillRef.current.getEditor();
      editor.history.undo();
    }
  }, [quillRef]);

  const handleRedo = useCallback(() => {
    if (quillRef.current) {
      const editor = quillRef.current.getEditor();
      editor.history.redo();
    }
  }, [quillRef]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === "z") {
        handleUndo();
      } else if (event.ctrlKey && event.key === "y") {
        handleRedo();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleUndo, handleRedo]);

  return (
    <ReactQuill
      theme="snow"
      ref={quillRef}
      modules={modules}
      placeholder={placeholder}
      className="custom-quill-container"
    />
  );
};
